module.exports = __webpack_public_path__ + "static/media/baccarat.skywind.e1f7ca31.jpeg";